import { fromJS } from 'immutable'

import {
  FETCH_STARTED,
  FILTER_CHANGED,
  UPDATE_CLAIMS,
  STATUS_CLAIM
} from 'scenes/Claims/constants'


export const initialState = fromJS({
  locationKey: null,
  claims: [],
  isFetching: false,
  filters: {
    q: '',
    ct: null, // client_type,
    t: null, // type
    ws: null, // workshop
    ic: null, // company
    ib: null, // broker
    s: null, // state
    c: null, // city
    status: 'Course',
    ordering: null
  },
  pagination: {
    next: null
  },
  status: 'Course'
})

export default function reducer(state = initialState, action) {
  let filters
  switch(action.type) {
    case FETCH_STARTED:
      return state.set('isFetching', true)
    case FILTER_CHANGED:
      filters = state.get('filters')
      filters = filters.set(action.filter, action.value)
      return state.set('filters', filters)
    case UPDATE_CLAIMS:
      const prevClaims = state.get('claims')
      const claims = action.isNextPage ? prevClaims.concat(fromJS(action.claims)) : fromJS(action.claims)
      return state.merge({
        'claims': claims,
        'isFetching': false,
        pagination: {
          next: action.nextPage
        }
      })
    case STATUS_CLAIM:
      return state.set('status', action.status)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Claims/reducer.js